import React from 'react';
import * as reduxSelectors from '../store/application.reducers';
import {connect} from 'react-redux';
import translate from '../translations/translations.wrapper.jsx';
import ConfigurationWrapper from './ConfigurationWrapper.component';
import { confirmLeavingPage } from "utils/leavePageConfirmation.function";
import { useModalContext } from "components/modals/ModalContext";

export class Configuration extends ConfigurationWrapper {

    componentDidUpdate(prevProps, prevState, snapshot) {
        super.componentDidUpdate?.(prevProps, prevState, snapshot);
        if (this.props.toggleModal) {
            if (this.state.showWarning && !prevState.showWarning) {
                confirmLeavingPage({
                    toggleModal: this.props.toggleModal,
                    translate: this.props.translate,
                    stay: () => this.remain(),
                    leave: () => this.leave(),
                });
            }
        }
    }

    buildContent() {
        let frameStyle = {
            height: "80vh",
            marginTop: "36px"
        };

        return (
            <div>
                <iframe ref="old_settings"
                        title={"Old Settings"}
                        className="col-md-12 no-padding"
                        style={frameStyle}
                        frameBorder="0"
                        height="85vh"
                        src={"/approval/settings.xhtml?contextSelector:switchContext=" + this.props.currentContextId}/>
            </div>
        )
    }
}

const withTranslations = translate(Configuration);
const mapStateToProps = function (store) {
    return {
        currentContextId: reduxSelectors.getUsersCurrentContextId(store),
        businessFeatures: reduxSelectors.getUsersCurrentBusinessFeatures(store)
    };
};

const Connected = connect(mapStateToProps, {})(withTranslations);

const ConfigurationWithModal = (props) => {
    const modalContext = useModalContext();
    const {toggleModal} = modalContext || {};
    return <Connected {...props} toggleModal={toggleModal} />;
};

export default ConfigurationWithModal;

